import chair1 from "../../Assets/ExploreAssets/Chair1.png";
import chair2 from "../../Assets/ExploreAssets/chair2.png";
import chair3 from "../../Assets/ExploreAssets/chair3.png";
import chair4 from "../../Assets/ExploreAssets/Chair1.png";
import chair5 from "../../Assets/ExploreAssets/chair3.png";

export const products = [
  {
    productType: "Chair",
    productItems: [
      {
        name: "Bistro Chair",
        price: "321",
        id: "1",
        img: chair1,
      },
      {
        name: "Era Chair",
        price: "121",
        id: "2",
        img: chair2,
      },
      {
        name: "Windsor Chair",
        price: "821",
        id: "3",
        img: chair3,
      },
      {
        name: "Phillipe Chair",
        price: "427",
        id: "4",
        img: chair4,
      },
      {
        name: "Nice Chair",
        price: "221",
        id: "5",
        img: chair5,
      },
      {
        name: "Beaut Chair",
        price: "522",
        id: "6",
        img: chair3,
      },
      {
        name: "Roll Chair",
        price: "421",
        id: "7",
        img: chair2,
      },
      {
        name: "Bistro Chair",
        price: "321",
        id: "1",
        img: chair1,
      },
      {
        name: "Era Chair",
        price: "121",
        id: "2",
        img: chair2,
      },
    ],
    id: "1",
  },
  {
    productType: "Cofee Tables",
    productItems: [
      {
        name: "Roll Chair",
        price: "421",
        id: "7",
      },
      // {
      //   name: "Roll Chair",
      //   price: "421",
      //   id: "7",
      // },
    ],
    id: "2",
  },
  {
    productType: "Beds",
    productItems: [],
    id: "3",
  },
  {
    productType: "Sofas",
    productItems: [],
    id: "4",
  },
  {
    productType: "Consoles",
    productItems: [],
    id: "5",
  },
  {
    productType: "Tables",
    productItems: [],
    id: "6",
  },
  {
    productType: "Soft seating",
    productItems: [],
    id: "7",
  },
];
